(() => {
  'use strict';

  window.CS = window.CS || {};
  window.CS.motion = window.CS.motion || {};

  const tokens = Object.freeze({
    version: '1.0.0',
    duration: Object.freeze({
      instant: 150,
      fast: 250,
      normal: 450,
      editorial: 700,
      cinematic: 1100
    }),
    distance: Object.freeze({
      xs: 8,
      sm: 16,
      md: 24,
      lg: 40,
      xl: 64,
      hero: 96
    }),
    opacity: Object.freeze({
      ghost: 0.03,
      subtle: 0.08,
      soft: 0.18,
      medium: 0.35,
      strong: 0.72,
      full: 1
    }),
    easing: Object.freeze({
      interface: 'cubic-bezier(.2,.8,.2,1)',
      smooth: 'cubic-bezier(.25,.46,.45,.94)',
      editorial: 'cubic-bezier(.22,1,.36,1)',
      cinematic: 'cubic-bezier(.16,1,.3,1)',
      linear: 'linear'
    }),
    stagger: Object.freeze({
      tight: 60,
      normal: 90,
      relaxed: 140,
      editorial: 180
    }),
    scale: Object.freeze({
      subtleIn: 0.985,
      softIn: 0.97,
      full: 1
    }),
    blur: Object.freeze({
      subtle: 4,
      soft: 8,
      editorial: 14
    }),
    viewport: Object.freeze({
      thresholdLow: 0.12,
      thresholdNormal: 0.18,
      thresholdHigh: 0.35,
      rootMarginDefault: '0px 0px -8% 0px',
      rootMarginEarly: '0px 0px 4% 0px'
    }),
    breakpoint: Object.freeze({
      mobile: 749,
      tablet: 900,
      desktop: 1100
    }),
    reveal: Object.freeze({
      fade: Object.freeze({ duration: 'normal', easing: 'smooth' }),
      fadeUp: Object.freeze({ duration: 'editorial', distance: 'md', easing: 'editorial' }),
      fadeLeft: Object.freeze({ duration: 'editorial', distance: 'md', easing: 'editorial' }),
      fadeRight: Object.freeze({ duration: 'editorial', distance: 'md', easing: 'editorial' }),
      scale: Object.freeze({ duration: 'editorial', scale: 'softIn', easing: 'editorial' }),
      line: Object.freeze({ duration: 'normal', easing: 'linear' }),
      word: Object.freeze({ duration: 'editorial', distance: 'sm', easing: 'editorial' }),
      mask: Object.freeze({ duration: 'editorial', easing: 'cinematic' }),
      blur: Object.freeze({ duration: 'editorial', blur: 'soft', easing: 'editorial' })
    }),
    story: Object.freeze({
      A: Object.freeze({
        name: 'Editorial Intro',
        order: Object.freeze(['badge','title','line','text','cta']),
        stagger: 'relaxed'
      }),
      B: Object.freeze({
        name: 'Problem / Metric',
        order: Object.freeze(['number','title','text']),
        stagger: 'normal'
      }),
      C: Object.freeze({
        name: 'Visual Proof',
        order: Object.freeze(['image','title','cta']),
        stagger: 'relaxed'
      })
    })
  });

  Object.defineProperty(window.CS.motion, 'tokens', {
    value: tokens,
    writable: false,
    configurable: false,
    enumerable: true
  });

  window.CS.motion.get = (group, name) => {
    if (!tokens[group] || !(name in tokens[group])) {
      console.warn(`[CS Motion] Token not found: ${group}.${name}`);
      return undefined;
    }
    return tokens[group][name];
  };

  window.CS.motion.ms = (name) => {
    const v = tokens.duration[name];
    return typeof v === 'number' ? `${v}ms` : undefined;
  };

  window.CS.motion.px = (group, name) => {
    const source = tokens[group];
    const v = source && source[name];
    return typeof v === 'number' ? `${v}px` : undefined;
  };

  document.documentElement.dataset.csMotionTokens = tokens.version;

  window.dispatchEvent(new CustomEvent('cs:motion-tokens-ready', {
    detail: { version: tokens.version }
  }));
})();
